module.exports = __webpack_public_path__ + "td/img/cost-cash-1.ce68d90b.png";